export default {
    mounted(el, binding) {
      const opts = binding.value || {};
      const minW = opts.minW ?? 320;
      const minH = opts.minH ?? 240;
      const maxW = opts.maxW ?? 1600;
      const maxH = opts.maxH ?? 1000;
  
      const computed = window.getComputedStyle(el);
      if (computed.position === "static") el.style.position = "fixed";
      if (window.getComputedStyle(el).position === "static") el.style.position = "fixed";
      if (window.getComputedStyle(el).position === "static") el.style.position = "relative";
  
      // ✅ 右下角 resize handle（强制可见样式，不依赖外部 CSS）
      const grip = document.createElement("div");
      grip.className = "resize-grip";
      grip.style.position = "absolute";
      grip.style.right = "6px";
      grip.style.bottom = "6px";
      grip.style.width = "18px";
      grip.style.height = "18px";
      grip.style.cursor = "nwse-resize";
      grip.style.zIndex = "99999";
      grip.style.borderRight = "3px solid rgba(0,0,0,0.45)";
      grip.style.borderBottom = "3px solid rgba(0,0,0,0.45)";
      grip.style.borderRadius = "2px";
      grip.style.background = "rgba(255,255,255,0.35)";
  
      el.appendChild(grip);
  
      let resizing = false;
      let startX = 0, startY = 0;
      let startW = 0, startH = 0;
  
      const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  
      const onMove = (e) => {
        if (!resizing) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
  
        const nextW = clamp(startW + dx, minW, maxW);
        const nextH = clamp(startH + dy, minH, maxH);
  
        el.style.width = `${nextW}px`;
        el.style.height = `${nextH}px`;
      };
  
      const onUp = () => {
        resizing = false;
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
        document.body.style.userSelect = "";
      };
  
      const onDown = (e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
  
        resizing = true;
        startX = e.clientX;
        startY = e.clientY;
  
        const rect = el.getBoundingClientRect();
        startW = rect.width;
        startH = rect.height;
  
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
        document.body.style.userSelect = "none";
      };
  
      grip.addEventListener("mousedown", onDown);
  
      el.__resizableCleanup__ = () => {
        grip.removeEventListener("mousedown", onDown);
        grip.remove();
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
      };
    },
  
    unmounted(el) {
      el.__resizableCleanup__?.();
      delete el.__resizableCleanup__;
    },
  };
  